export default "__VITE_ASSET__CA$2S9Mt__"